export class AppError extends Error {
  constructor(message) {
    super(message);
    this.name = this.constructor.name;
  }
}

export class NetworkError extends AppError {
  constructor(error) {
    super(error.status);
    this.name = this.constructor.name;
  }
}
